import { DOWNLOADABLE_FILE_TYPES, VIEWABLE_FILE_TYPES } from '@exam-center/utils';

function getFileMode(type: string) {
  if (VIEWABLE_FILE_TYPES.includes(type)) return 'preview' as const;
  if (DOWNLOADABLE_FILE_TYPES.includes(type)) return 'download' as const;
}

export function mapStorageObjectToFileNames(
  storageObjects: {
    name: string;
    type: string;
    value: {
      url: string;
      name: string;
    };
  }[],
) {
  const transformedStorageObjects = storageObjects.map((file) => ({
    name: file.name,
    mode: getFileMode(file.type),
    value: {
      url: file.value.url,
      name: file.value.name,
    },
  }));
  return transformedStorageObjects;
}
